<template>
    <div class="customer-profile-listing">
        <CreateNewCustomerModal :show_new_customer.sync="modals.show_new_customer"/>
        <base-header class="pb-6">
            <b-row align-v="center" class="py-3">
                <b-col cols="6">
                    <p class="text-muted">Profile</p>
                    <h2 class="listing-title d-inline-block mb-0">Customer Profile</h2>
                </b-col>
                <b-col cols="6" class="text-right ">
                    <base-button v-show="backButton" type="primary" icon size="sm" @click="close()">
                        <span class="btn-inner--text">Back / Close</span>
                    </base-button>
										<b-button variant="primary" class="btn-header" 
                        @click="modals.show_new_customer = true"
                        v-if="checkAccess(['c_customer__create']) && !checkAppCode('sas')"
                    >Create Customer</b-button>
                </b-col>
            </b-row>
        </base-header>
        <b-container fluid class="mt--6">
            <CustomerProfileListingIndividualTable :is_page_advisory="false" />
        </b-container>
    </div>
</template>
<script>
    import { Tabs, TabPane } from 'element-ui'
    import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb'
    import CustomerProfileListingIndividualTable from '@/views/CustomerProfile/CustomerProfileListings/IndividualTable'
    import CustomerProfileListingJointTable from '@/views/CustomerProfile/CustomerProfileListings/JointTable'
    import CreateNewCustomerModal from '@/views/CustomerProfile/CustomerModals/CustomerTable/CreateNewCustomerModal'
    import helperFunctionMixin from '@/assets/js/helperFunctionMixin.js'
		
    export default {
        components: {
            CustomerProfileListingIndividualTable,
            CustomerProfileListingJointTable,
            RouteBreadCrumb,
            CreateNewCustomerModal,
            [Tabs.name]: Tabs,
            [TabPane.name]: TabPane,
        },
        mixins:[helperFunctionMixin],
        data() {
            return {
                modals:{
                    show_new_customer: false
                },
                backButton: false,
            };
        },
        created() {
            if(this.$route.params.token)
            {
                this.backButton = true;
            }
        },
        methods: {
            close() {
                if(this.$route.params.token)
                {
                    // window.location.href = "https://sas.imortgage2u.com/portal/initialSettlement/proposal/"+this.$route.params.proposal_id;
                    window.history.back();
                    window.close();
                }
                else
                {
                    this.$router.back();
                }
            }
        }
    }
</script>